// extracted by mini-css-extract-plugin
export default {"callAvatar":"CallAvatar_callAvatar","disabledPointerEvents":"CallAvatar_disabledPointerEvents","autoPointerEvents":"CallAvatar_autoPointerEvents"};